module.exports = __webpack_public_path__ + "static/media/20210401_214252_067_IMG_0055.6bc69584.jpg";